// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"dashboard_dashboardContainer__kFy11","baseBadge":"dashboard_baseBadge__5Hhc7"};